var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNormalLightBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 52,
    viewBox: "0 0 62 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2823_7782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5 29.2727C53.5 45.8182 31 60 31 60C31 60 8.5 45.8182 8.5 29.2727C8.5 23.6308 10.8705 18.22 15.0901 14.2306C19.3097 10.2412 25.0326 8 31 8C36.9674 8 42.6903 10.2412 46.9099 14.2306C51.1295 18.22 53.5 23.6308 53.5 29.2727Z",
    fill: "#7E818A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2823_7782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1065 18.1165C37.4883 17.7795 36.7793 17.6553 36.0857 17.7624L22.0402 19.7674C19.9497 20.0684 18.2555 22.162 18.2512 24.4592L18.225 39.8578C18.197 40.5098 18.3444 41.1572 18.6513 41.7304C18.9583 42.3036 19.4132 42.7809 19.9671 43.111L24.5749 45.6605C24.022 45.3293 23.5679 44.8517 23.2611 44.2788C22.9543 43.7059 22.8063 43.059 22.8328 42.4073L22.8633 27.0219C22.8633 24.7292 24.5619 22.6356 26.6524 22.3346L40.6979 20.3119C41.39 20.2048 42.0977 20.329 42.7143 20.666L38.1065 18.1165Z",
    fill: "#C3C5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0069 19.9731C42.093 19.6765 43.7828 21.3009 43.7785 23.5804L43.7523 38.9834C43.7523 41.2762 42.0495 43.3742 39.9633 43.6752L25.9178 45.6802C23.8273 45.9768 22.1418 44.3524 22.1418 42.0729L22.1723 26.6831C22.1723 24.3904 23.8709 22.2968 25.9614 21.9958L40.0069 19.9731Z",
    fill: "#EFF5F2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2823_7782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1326 25.9851L27.4526 34.1316H33.4646L32.7966 39.5627L39.4765 31.4161H33.4646L34.1326 25.9851Z",
    fill: "#7E818A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2823_7782",
    x: 0.5,
    y: 0,
    width: 61,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.34902 0 0 0 0 0.356863 0 0 0 0 0.392157 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2823_7782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2823_7782",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2823_7782",
    x: 16.2217,
    y: 15.725,
    width: 33.5569,
    height: 35.9901,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.34902 0 0 0 0 0.358366 0 0 0 0 0.392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2823_7782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2823_7782",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2823_7782",
    x: 23.4526,
    y: 23.9851,
    width: 20.0239,
    height: 21.5775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.188235 0 0 0 0 0.215686 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2823_7782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2823_7782",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalLightBox);
export default __webpack_public_path__ + "static/media/normal_light_box.24cf4bbbc2e16254fa36fc4a1a3edba7.svg";
export { ForwardRef as ReactComponent };